var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowing)?_c('div',{ref:"interactElement",staticClass:"card",class:[{
    isAnimating: _vm.isInteractAnimating,
    isCurrent: _vm.isCurrent
  } ],style:({ transform: _vm.transformString }),on:{"click":_vm.mobileFix}},[_c('p',{staticClass:"instructions",class:{ 'instructions-mobile': _vm.isMobile },domProps:{"innerHTML":_vm._s(_vm.prettyInstructions(_vm.card.content))}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }